<div class="wallet-wrapper container py-4">

  <div class="wallet-card">

    <!-- HEADER -->
    <div class="wallet-header">
      <h3>Wallet</h3>
      <div class="wallet-divider"></div>
    </div>


    <!-- BALANCE SECTION -->
    <div class="wallet-balance">

      <div class="balance-box">
        <p>Available Balance</p>
        <h2>
          {{ acc < 1 ? '$0.00' : (acc | currency) }}
        </h2>
      </div>

      <div class="balance-box pending">
        <p>Pending</p>
        <h3>$ {{ pwith }}</h3>
      </div>

    </div>


    <!-- NOTICE -->
    <div class="wallet-alert" *ngIf="trust_access == 1">
      Withdrawals of <b>$1000+</b> are processed via partner wallet
      <a href="https://xenhold.com" target="_blank">Xenhold</a>
    </div>


    <!-- WITHDRAW FORM -->
    <div *ngIf="display == 1" class="withdraw-panel">

      <form (ngSubmit)="withdraw(so)" #so="ngForm">

        <!-- Amount -->
        <label>Withdrawal Amount</label>
        <div class="input-lux">
          <input
            type="number"
            required
            [(ngModel)]="val"
            name="withdraw"
            placeholder="Enter amount"
          />
          <span>USD</span>
        </div>


        <!-- Destination -->
        <label class="mt-3">Withdraw To</label>
        <select name="withdrawto" ngModel required class="lux-select">
          <option value="" disabled selected>Select wallet</option>

          <option *ngIf="xrp && xrp != 'Not set'" value="xrp">
            XRP — {{ xrp }}
          </option>

          <option *ngIf="usdtbep && usdtbep != 'Not set'" value="USDT(BEP20)">
            USDT BEP20 — {{ usdtbep }}
          </option>

          <option *ngIf="usdttrc && usdttrc != 'Not set'" value="USDT(TRC20)">
            USDT TRC20 — {{ usdttrc }}
          </option>

          <option *ngIf="eth && eth != 'Not set'" value="ETH">
            ETH — {{ eth }}
          </option>

          <option *ngIf="btc && btc != 'Not set'" value="BTC">
            BTC — {{ btc }}
          </option>

          <option *ngIf="country == 'India' && bank && bank != 'Not set'" value="Bank">
            Bank — {{ bank }}
          </option>

          <option *ngIf="country == 'India' && upi && upi != 'Not set' && upis == '1'" value="UPI">
            UPI — {{ upi }} ({{ upname }})
          </option>

        </select>


        <!-- Submit -->
        <button
          class="lux-btn mt-4"
          [disabled]="!so.valid"
          *ngIf="acc >= withlimit"
        >
          Initiate Withdrawal
        </button>

        <div class="wallet-error" *ngIf="acc < withlimit">
          Insufficient balance to withdraw
        </div>

      </form>

    </div>


    <!-- ACTION BUTTONS -->
    <div class="wallet-actions">

      <button
        class="btn-open"
        *ngIf="display == 0"
        (click)="display = 1">
        Withdraw Funds
      </button>

      <button
        class="btn-update"
        *ngIf="!xrp"
        routerLink="../profile">
        Update Wallet Address
      </button>

    </div>

  </div>
</div>
